module.exports = __webpack_public_path__ + "static/img/logo-min.228dc4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-min.png
// module id = uoKR
// module chunks = 152